import { Container } from '@tencent/alloy-renderer';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { getFlip } from '@editor/src/page/index/components/canvas/element-types/shape-element/utils';
import { isFlipH, isFlipV } from '@editor/src/page/index/components/canvas/common';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

/**
 * 更新wrapper位移、旋转、翻转
 * @param component 要将位移、旋转、翻转效果应用到的Container
 * @param factoryOptions 当前图形透传的factoryOptions
 */
export const updateWrapperTransform = (component: Container, factoryOptions: InterfaceFactoryOptions): Container => {
    const rect = factoryOptions.frame!;
    const flip = getFlip(rect, factoryOptions?.model?.props);
    return updateContainerTransform(component, {
        ...rect,
        ...flip,
    });
};

export function updateContainerTransform(component: Container, frame: IFrame) {
    const { left, top, width, height, rotate } = frame;
    // 设置位移以及旋转的中心点（为了避免浮点数坐标造成的模糊，均向下取整）
    component.x = Math.floor(left) + Math.floor(width / 2); // pivotX的设置会令图像产生负向平移，所以需要补回来
    component.y = Math.floor(top) + Math.floor(height / 2);
    component.pivotX = Math.floor(width / 2);
    component.pivotY = Math.floor(height / 2);
    // 旋转
    rotate !== undefined && (component.angle = rotate);
    // 翻转
    component.scaleX = isFlipH(frame) ? -1 : 1;
    component.scaleY = isFlipV(frame) ? -1 : 1;
    return component;
}
